import React from 'react';
import { Edit2, Trash2, AlertCircle } from 'lucide-react';

const CategoryCard = ({ category, onEdit, onDelete, showUsageWarning = false }) => {
  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow">
      <div className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-primary-black mb-1">
              {category.name || category.dimension}
            </h3>
            <p className="text-sm text-gray-500">
              Created {new Date(category.created_at).toLocaleDateString()}
            </p>
          </div>

          {/* Actions */}
          <div className="flex gap-2 ml-4">
            <button
              onClick={() => onEdit(category)}
              className="p-2 text-gray-600 hover:text-accent-gold hover:bg-gray-100 rounded-lg transition-colors"
              title="Edit"
            >
              <Edit2 className="w-4 h-4" />
            </button>
            <button
              onClick={() => onDelete(category)}
              className="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              title="Delete"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        </div>

        {showUsageWarning && (
          <div className="mt-3 flex items-center gap-2 p-2 bg-yellow-50 border border-yellow-200 rounded">
            <AlertCircle className="w-4 h-4 text-yellow-600 flex-shrink-0" />
            <p className="text-xs text-yellow-800">In use by products - cannot be deleted</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryCard;
